import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/free-solid-svg-icons";
// import { faFacebookF, faGithub, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { Col, Row, Form, Card, Button, FormCheck, Container, InputGroup } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../../routes";
import BgImage from "../../assets/img/illustrations/signin.svg";
import { useHistory } from "react-router-dom";


import React, { useState, useEffect } from "react";
import { verifyOTP, resendOTP } from "../../api/services";


export default function OtpVerify() {
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [timeLeft, setTimeLeft] = useState(30);
    const history = useHistory();
    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (password !== confirmPassword) {
        //     alert("Passwords do not match");
        //     return;
        // }
        const email = sessionStorage.getItem("email");
        console.log({ otp });

        try {
            const data = await verifyOTP({
                email,
                otp
            });

            console.log("OTP Verify Success:", data);

            setSuccess("Your Account is Verified!!");
            await delay(2000); // Waits for 1 second

            history.push(Routes.Signin.path);

        } catch (error) {
            setError(error.response?.data.error);
            console.log("OTP Verify Error:", error.response?.data || error.message);
        }
    };

    const handleResend = async () => {
        console.log("resend clicked!");
        const email = sessionStorage.getItem("email");
        console.log({ otp });

        try {
            const data = await resendOTP({
                email
            });

            console.log("OTP Resend Success:", data);
            setSuccess("OTP has been Resend.")
            setTimeLeft(30);
            // await delay(2000); // Waits for 1 second

            // history.push(Routes.Signin.path);

        } catch (error) {
            setError(error.response?.data.error);
            console.log("OTP Verify Error:", error.response?.data || error.message);
        }
    }

    const formatTime = (seconds) => {
        const min = Math.floor(seconds / 60);
        const sec = seconds % 60;
        return `${min}:${sec < 10 ? "0" : ""}${sec}`;
    };

    useEffect(() => {
        if (timeLeft <= 0) return;

        const interval = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [timeLeft]);

    return (
        <main >
            <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
                <Container>
                    <Row className="justify-content-center form-bg-image" style={{ backgroundImage: `url(${BgImage})` }}>
                        <Col xs={12} className="d-flex align-items-center justify-content-center">
                            <div className="mb-4 mb-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                                <div className="text-center text-md-center mb-4 mt-md-0">
                                    <h3 className="mb-0">Verify Your Account</h3>
                                </div>

                                {
                                    success && (<div class="alert alert-success">
                                        {success}
                                    </div>)
                                }

                                {
                                    error && (<div class="alert alert-danger">
                                        {error}
                                    </div>)
                                }
                                <Form className="mt-4" onSubmit={handleSubmit}>
                                    <Form.Group id="otp" className="mb-4">
                                        {/* <Form.Label>OTP</Form.Label> */}
                                        <InputGroup>
                                            <InputGroup.Text>
                                                <FontAwesomeIcon icon={faKey} />
                                            </InputGroup.Text>

                                            <Form.Control
                                                autoFocus
                                                required
                                                type="otp"
                                                placeholder="Enter OTP"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                    <Button variant="primary" type="submit" className="w-100">
                                        Verify
                                    </Button>

                                    {timeLeft === 0 && (
                                        // <button onClick={handleResend}>
                                        //     Resend OTP
                                        // </button>
                                        <Button onClick={handleResend} variant="primary" className="w-100 mt-2">
                                            Resend
                                        </Button>
                                    )}
                                </Form>
                                <div className="text-center text-md-center mt-2 text-red">
                                    <p className="mb-0">OTP is valid for 5 min </p>
                                </div>
                                <div className="text-center text-md-center mt-2">
                                    <p className="mb-0">Resend will available in: {formatTime(timeLeft)}</p>
                                </div>
                                <div className="mt-3 mb-4 text-center">
                                    <span className="fw-normal">or</span>
                                </div>
                                {/* <div className="d-flex justify-content-center my-4">
                                    <Button variant="outline-light" className="btn-icon-only btn-pill text-facebook me-2">
                                        <FontAwesomeIcon icon={faFacebookF} />
                                    </Button>
                                    <Button variant="outline-light" className="btn-icon-only btn-pill text-twitter me-2">
                                        <FontAwesomeIcon icon={faTwitter} />
                                    </Button>
                                    <Button variant="outline-light" className="btn-icon-only btn-pil text-dark">
                                        <FontAwesomeIcon icon={faGithub} />
                                    </Button>
                                </div> */}

                                <div className="d-flex justify-content-center align-items-center mt-4">
                                    <span className="fw-normal">
                                        Already have an account?
                                        <Card.Link as={Link} to={Routes.Signin.path} className="fw-bold">
                                            {` Login here `}
                                        </Card.Link>
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </main>
    );
};